var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55313 5.45645C8.55313 5.10944 8.27181 4.82812 7.9248 4.82812C7.5778 4.82812 7.29648 5.10944 7.29648 5.45645V7.34141H5.41152C5.06451 7.34141 4.7832 7.62273 4.7832 7.96973C4.7832 8.31673 5.06451 8.59805 5.41152 8.59805H7.29648V10.483C7.29648 10.83 7.5778 11.1113 7.9248 11.1113C8.27181 11.1113 8.55313 10.83 8.55313 10.483V8.59805H10.4381C10.7851 8.59805 11.0664 8.31673 11.0664 7.96973C11.0664 7.62273 10.7851 7.34141 10.4381 7.34141H8.55313V5.45645Z",
    fill: "#475569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 0.833008C4.04261 0.833008 0.833984 4.04163 0.833984 7.99967C0.833984 11.9577 4.04261 15.1663 8.00065 15.1663C11.9587 15.1663 15.1673 11.9577 15.1673 7.99967C15.1673 4.04163 11.9587 0.833008 8.00065 0.833008ZM1.83398 7.99967C1.83398 4.59392 4.5949 1.83301 8.00065 1.83301C11.4064 1.83301 14.1673 4.59392 14.1673 7.99967C14.1673 11.4054 11.4064 14.1663 8.00065 14.1663C4.5949 14.1663 1.83398 11.4054 1.83398 7.99967Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.6629d804ea7eca7f057b0cc1d21687d0.svg";
export { ForwardRef as ReactComponent };